
import { Vue } from "vue-class-component";

export default class ProfileIcon extends Vue {}
